const readImage = (file) => {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      var image = new Image();
      image.src = e.target.result;
      image.onload = () => {
        const height = image.height;
        const width = image.width;
        resolve({
          data: e.target.result,
          width,
          height,
        });
      };

      return;
    };

    if (!file) {
      resolve({
        data: null,
        width: 0,
        height: 0,
      });
      return;
    }

    reader.readAsDataURL(file);
  });
};

export default {
  readImage,
};
